import { Component } from '@angular/core';

@Component({
  selector: 'terms-root',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent {
  title = 'SWEIT INFOTECH';
}
